document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener("click", function(e) {
        if (e.target.closest(".dropbtn")) {
            toggleMenu(e.target.closest(".dropbtn"));
        }

        if (e.target.closest(".c-hamburger__menu")) {
            toggleHamburgerMenu();
        }

        if (e.target.closest(".js-toggleSiteSearch")) {
            e.preventDefault();
            toggleSiteSearch();
        }
    });
});

const toggleMenu = (menuToggle) => {
    menuToggle.parentNode?.classList.toggle("is-active");
    menuToggle.classList.toggle("is-active");
    menuToggle.nextElementSibling?.classList.toggle("is-active");
}

const toggleSiteSearch = () => {
    const wrapper = document.querySelectorAll(".c-site-search-bar__container");
    const siteHeader = document.querySelector(".c-site-search--desktop .c-site-search__input");

    wrapper.forEach((e) => {
        e.classList.toggle("is-active");
    });

    if (wrapper[0].classList.contains("is-active")) {
        siteHeader.focus();
    }

    document.querySelector(".c-site-search__toggle .gg").classList.toggle("gg--search");
    document.querySelector(".c-site-search__toggle .gg").classList.toggle("gg--close-r");
    document.querySelector(".c-site-search__toggle").classList.toggle("is-active");
    document.querySelector(".c-site-search__form").classList.toggle("is-active");
}

const toggleHamburgerMenu = () => {
    document.querySelector("body").classList.toggle("mobileNavActive");

    let elements = [
        document.querySelector(".c-menu-nav__container"),
        document.querySelector(".menu-content"),
        document.querySelector(".c-dropdown"),
        document.querySelector(".t1-parent__container"),
        document.querySelector(".c-site-menu__toggle")
    ];

    elements.filter(function(element) {
        return element !== null;
    }).forEach(function(ele) {
        ele.classList.toggle("is-active");
    });
}
